import VisibleComponent from '../VisibleComponent'
import Button from "../Button";
import './index.less'

const template = `
    <div class="mtg-panel mtg-panel-wrap">
        <div class="mtg-panel-title-wrap">
            <div class="mtg-panel-title"></div>
            <div class="mtg-panel-title-tools"></div>
        </div>
        <div class="mtg-panel-content"></div>
    </div>
`

/**
 * Panel 面板类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Panel extends VisibleComponent {
    constructor (options={}) {
        super(options)

        this.template = template
        this.init(options)
    }

    init(options){
        super.init(options)

        this.wrap = this.element
        this.titleWrap = this.element.querySelector('.mtg-panel-title-wrap')
        this.title = this.titleWrap.children[0]
        this.titleTools = this.titleWrap.children[1]
        this.content = this.element.querySelector('.mtg-panel-content')

        const {
            width,
            height,
            title,
            padding = '0',
            content,
            wrapClassName = '',
            titleClassName = '',
            contentClassName = '',
            titleToolsClassName = '',
            titleTools = [],
            titleCenter,
            icon,
        } = options

        width && (this.wrap.style.width = width)
        height && (this.wrap.style.height = height)
        padding && (this.wrap.style.padding = padding)

        wrapClassName && this.wrap.classList.add(wrapClassName)
        titleClassName && this.title.classList.add(titleClassName)
        contentClassName && this.content.classList.add(contentClassName)
        titleToolsClassName && this.titleTools.classList.add(titleToolsClassName)

        title ? (this.title.innerHTML = title) : (this.title.style.display='none')
        titleCenter && (this.title.style.textAlign = 'center')
        this.initButtonGroup(titleTools, this.titleTools)

        if(typeof content === 'string'){
            this.content.innerText = content
            this.content.classList.add('mtg-panel-text-content')
        }else if(content instanceof HTMLElement){
            this.content.appendChild(content)
            this.content.classList.add('mtg-panel-custom-content')
        }else if(content instanceof VisibleComponent){
            this.content.appendChild(content.element)
            this.content.classList.add('mtg-panel-custom-content')
        }
    }


    initButtonGroup(buttonGroup, appendToElement) {
        buttonGroup.forEach(config => {
            const btn = new Button(config)
            btn.appendTo(appendToElement)
        })
    }


}

export default Panel